
import React, { forwardRef, useEffect } from 'react';
import { Bank } from './types';
import BankSelector from './BankSelector';
import PaymentButton from './PaymentButton';

interface PaymentFormProps {
  availableBanks: Bank[];
  selectedBank: string | null;
  onBankSelect: (bankId: string) => void;
  onSubmit: () => void;
  isProcessing: boolean;
}

const PaymentForm = forwardRef<HTMLFormElement, PaymentFormProps>(({
  availableBanks,
  selectedBank,
  onBankSelect,
  onSubmit,
  isProcessing
}, ref) => {
  // Log props on mount to verify data flow
  useEffect(() => {
    console.log("PaymentForm laetud parameetritega:", { 
      banksCount: availableBanks.length, 
      selectedBank, 
      isProcessing 
    });
  }, [availableBanks, selectedBank, isProcessing]);

  const handleFormSubmit = (e: React.FormEvent) => {
    // This prevents the default form submit behavior
    e.preventDefault();
    console.log("💥 PaymentForm: Vormi esitamine takistatud");
  };

  const handleButtonClick = () => {
    console.log("💥 PaymentForm: Nupu kliki käitleja käivitatud pangaga:", selectedBank);
    
    if (!selectedBank) {
      console.log("💥 PaymentForm: Pank valimata, ei saa jätkata");
      return;
    }
    
    // Direct call to parent onSubmit passing the selected bank
    console.log("💥 PaymentForm: Kutsun vanema onSubmit()");
    onSubmit();
  };

  return (
    <form 
      ref={ref} 
      className="space-y-6" 
      onSubmit={handleFormSubmit}
    >
      <div id="montonio-checkout" className="mt-4 block" />
      
      <BankSelector 
        availableBanks={availableBanks}
        selectedBank={selectedBank}
        onBankSelect={onBankSelect}
      />
      
      <div className="mt-6 relative z-50">
        <PaymentButton 
          onSubmit={handleButtonClick}
          disabled={!selectedBank} 
          loading={isProcessing} 
          buttonText="Jätka maksega" 
        />
      </div>
    </form>
  );
});

PaymentForm.displayName = 'PaymentForm';

export default PaymentForm;
